import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformKeysToSnakeCase, transformV2ClientResponse } from 'helpers/core';

import URLS from 'constants/urls';

const bookingsHandler = ({ httpClient }, viewByUnit, viewByRange) => {
  const endpoint = URLS.reports.summary(
    transformKeysToSnakeCase({
      summaryType: 'bookings',
      viewByUnit,
      viewByRange,
    })
  );
  return httpClient.get(endpoint).then(transformV2ClientResponse);
};

const revenueHandler = ({ httpClient }, viewByUnit, viewByRange) => {
  const endpoint = URLS.reports.summary(
    transformKeysToSnakeCase({
      summaryType: 'revenue',
      viewByUnit,
      viewByRange,
    })
  );
  return httpClient.get(endpoint).then(transformV2ClientResponse);
};
export const reportsVenuesBookings = makeEntityScaffold('SAGA.API.REPORTS_VENUES_BOOKINGS', bookingsHandler, {
  defaultKey: [1, 2],
});
export const reportsVenuesRevenue = makeEntityScaffold('SAGA.API.REPORTS_VENUES_REVENUE', revenueHandler, {
  defaultKey: [1, 2],
});
